export const apiRoutes = {
  sendMessage: "sendMessage",
  listConversations: "listConversations",
  listMessage: "listMessages",
};
